module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Doris Grumbach\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Doris Grumbach, author of many novels and memoirs including "), _c('I', [_vm._v("Fifty Days of Solitude")]), _vm._v(","), _c('I', [_vm._v(" Life in a Day")]), _vm._v(", "), _c('I', [_vm._v("The Ladies")]), _vm._v(", and "), _c('I', [_vm._v("Chamber Music")]), _vm._v(", has been literary editor of the "), _c('I', [_vm._v("New Republic")]), _vm._v(", a nonfiction columnist for the "), _c('I', [_vm._v("New York Times Book Review")]), _vm._v(", a book reviewer for National Public Radio, and a bookseller in Washington, DC, and Maine. She lives in Philadelphia."), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/KjURHK/tc-custom/9781497676664.jpg?1705894055484",
      "alt": "This image is the cover for the book Life in a Day"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Life in a Day\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A look into the daily life of one of America’s great memoirists")]), _c('br'), _c('br'), _vm._v(" At seventy-seven Doris Grumbach is as sharp as ever, and in "), _c('i', [_vm._v("Life in a Day")]), _vm._v(" she examines the experiences of her later years, from the dreaded writer’s block to the many hours she has spent reading to the effects of an increasingly modern and interconnected world. Imbued with Grumbach’s characteristic candor and verve, "), _c('i', [_vm._v("Life in a Day")]), _vm._v(" is a celebration of the meaning to be found in the quotidian."), _c('br'), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0